// this file is automatically generated by git.version.ts script
export const versionInfo = {
    version: 'v1.1.3',
};
